// Entry for the script-tag build (dist/cdn/embed.js). The build exposes the
// default export as `window.Waylight`.
import Waylight from './index.js';

// The async snippet installs a stub with a `_q` call queue before this script
// loads. Snippets pasted before the rename put that stub on window.Bugflow, so
// drain both, then point window.Bugflow at the real API so those snippets keep
// working.
const stubs = new Set([window.Waylight, window.Bugflow]);
const queuedCalls = [...stubs].flatMap((stub) => (Array.isArray(stub?._q) ? stub._q : []));

window.Bugflow = Waylight;

// Replay after this bundle finishes assigning window.Waylight.
setTimeout(() => {
    queuedCalls.forEach(([method, ...args]) => {
        if (typeof Waylight[method] === 'function') {
            Waylight[method](...args);
        }
    });
}, 0);

export default Waylight;
